import { EvidenceTypesEnum } from '@insync-students-constants/evidenceTypes';
import { Assignment } from '@insync-students-lib/models';
import { CmsResourceView } from '@modules/Resources/useResourceView';
import { useMemo } from 'react';
export interface IVisibilityConfig {
  showDownloadButton: boolean;
  showCaption: boolean;
  showCopyrightButton: boolean;
  showLanguageDropdown: boolean;
  showAssignmentUploadButton: boolean;
  showAssignmentInstructions: boolean;
}
export function createVisibilityConfig(resourceView: CmsResourceView | null, assignment: Assignment | Partial<Assignment> | null): IVisibilityConfig {
  if (resourceView === null) {
    return {
      showDownloadButton: false,
      showCaption: false,
      showCopyrightButton: false,
      showLanguageDropdown: false,
      showAssignmentUploadButton: false,
      showAssignmentInstructions: false
    };
  }
  return {
    showDownloadButton: resourceView.isDownloadable,
    showLanguageDropdown: resourceView.hasMultipleLanguages,
    showCaption: resourceView.hasCaption,
    showCopyrightButton: resourceView.hasCopyright,
    showAssignmentUploadButton: assignment?.evidenceType === EvidenceTypesEnum.upload,
    showAssignmentInstructions: assignment?.instructions !== ''
  };
}
export const useVisibilityConfig = (resourceView: CmsResourceView | null, assignment: Assignment | Partial<Assignment> | null): IVisibilityConfig => useMemo(() => createVisibilityConfig(resourceView, assignment), [resourceView, assignment]);